// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Textarea_formWrapper__31H2K","formControl":"Textarea_formControl__3M4AI","formLabel":"Textarea_formLabel__3MUNt","inputWrapper":"Textarea_inputWrapper__zIhNd"};